var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  Comment #"+_vm._s(_vm.index + 1)+" .................................................................."),_c('br'),_vm._v("\n  Author: "),_c('b',[_vm._v(_vm._s(_vm.author))]),_c('br'),_vm._v("\n  Time: "),_c('b',[_vm._v(_vm._s(_vm.formatTime(_vm.time)))]),_c('br'),_c('i',[_vm._v(_vm._s(_vm.text))]),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }